export const getters = {
  bannieres (state) {
    return state.bannieres
  },
  banniere (state) {
    return state.banniere
  },  
  pagination(state){
    return state.pagination
  }
}
